import MetaTagCustom from "./MetaTagCustom/MetaTagCustom"

export {
  MetaTagCustom,
};
